import DonationForm from '@/core/components/forms/DonationForm/DonationForm';

export default DonationForm;
